import { Targeting, TargetingProvider } from "../interfaces/TargetingProvider";
import { AdContextData } from "../type";
import { makeCachedGet } from "../util/requestHelpers";

export enum ContentTargetingType {
    DV_BRANDSAFETY = "dv_brandsafety",
    CONTENT = "content"
}

export class ContentTargetingProvider implements TargetingProvider {

    targetingUrl = `${ process.env.ADS_SERVICE_ENDPOINT }/ad-targeting/content`;
    get: ReturnType<typeof makeCachedGet<Targeting>>;
    private timeoutInMs: number;
    adContextData: AdContextData;
    types: ContentTargetingType[];

    constructor(
        adContextData: AdContextData,
        targetingTypes: ContentTargetingType[],
        timeout: number = 5000
    ) {
        this.adContextData = adContextData;
        this.types = targetingTypes;
        this.get = makeCachedGet<Targeting>("ContentTargeting");
        this.timeoutInMs = timeout;
    }

    private buildUrl(): string {
        const targetingTypes = `?targeting_types=${ this.types.join(",") }&page_type=${ this.adContextData.adPageType }`;

        return this.types.reduce((prevUrl, type) => {
            if (type === ContentTargetingType.CONTENT) {
                // generate parameters based on adContextData
                const slugParam = this.adContextData.slug ? `&slug=${ encodeURIComponent(this.adContextData.slug) }` : "";
                const adCodeParam = this.adContextData.adCode ? `&ad_code=${ encodeURIComponent(this.adContextData.adCode) }` : "";
                const tickerIdParam = this.adContextData.tickerId ? `&ticker_id=${ encodeURIComponent(this.adContextData.tickerId) }` : "";
                const personIdParam = this.adContextData.personId ? `&person_id=${ encodeURIComponent(this.adContextData.personId) }` : "";
                const suidParam = this.adContextData.suid ? `&suid=${ encodeURIComponent(this.adContextData.suid) }` : "";

                return `${ prevUrl }${ slugParam }${ adCodeParam }${ tickerIdParam }${ personIdParam }${ suidParam }`;
            } else if (type === ContentTargetingType.DV_BRANDSAFETY) {
                return `${ prevUrl }&url=${ encodeURIComponent(window.location.href) }`;
            }

            return prevUrl;
        }, `${ this.targetingUrl }${ targetingTypes }`);
    }

    getTargeting(): Promise<Targeting> {
        if (this.types.length === 0) return Promise.resolve({});

        return this.get(this.buildUrl(), this.timeoutInMs, {});
    }

}
